export default {
  path: 'documents',
  component: () => import('@/views/business/inventory/documents/index.vue'),
  children: [
    {
      path: ':documentId/details',
      name: 'inventory.documents.details',
      component: () => import('@/views/business/inventory/documents/details.vue'),
      meta: {
        hideTabs: true,
      },
    },
    {
      path: 'create',
      name: 'inventory.documents.create',
      component: () => import('@/views/business/inventory/documents/details.vue'),
      meta: {
        hideTabs: true,
      },
    },
    {
      path: '',
      name: 'inventory.documents.list',
      component: () => import('@/views/business/inventory/documents/list.vue'),
    },
  ],
}
